import { gql } from '@apollo/client'


export const GET_ASSET_SUMMARY_REPORT = gql`
  query($id: ID!, $from: String!, $to: String, $channels: [String]) {
    asset(id: $id) {
      id
      uuid
      name
      deviceProperties (reportOnly: true) {
          id
          name
          unit
          deviceName
          deviceId
          deviceSerial
          propertyId
          groupId
          outOfServiceAt
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePropertiesHistory(reportOnly: true) {
          id
          name
          unit
          deviceName
          deviceId
          deviceSerial
          propertyId
          groupId
          outOfServiceAt
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePropertySummary(from: $from, to: $to) {
         name
         propertyGroupName
         mkt
         stdDev
         avg
         min
         max
         unit
         deviceName
         deviceTypeName
         serial
         deviceId
         outOfServiceAt
      }
      chart(channels: $channels, from: $from, to: $to) {
        nodes {
          name
          deviceName
          deviceSerial
          propertyGroupName
          unit
          avg
          min
          max
          time
        }
      }
    }
  }
`

export const GET_ASSET_SUMMARY_DAILY_REPORT = gql`
  query($id: ID!, $from: String!, $to: String, $assetDeviceProperties: [InputCustomReportAssetDeviceProperty!]) {
    asset(id: $id) {
      id
      uuid
      name
      deviceProperties (reportOnly: true) {
          id
          name
          unit
          deviceName
          deviceId
          deviceSerial
          propertyId
          groupId
          outOfServiceAt
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePropertiesHistory(reportOnly: true) {
          id
          name
          unit
          deviceName
          deviceId
          deviceSerial
          propertyId
          groupId
          outOfServiceAt
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePropertySummaryDaily(from: $from, to: $to, assetDeviceProperties: $assetDeviceProperties) {
         name
         propertyGroupName
         mkt
         stdDev
         avg
         min
         max
         unit
         time
         deviceName
         deviceTypeName
         serial
         deviceId
         outOfServiceAt
      }
    }
  }
`

export const GET_ASSET_JOURNEY_REPORT = gql`
  query($id: ID!, $from: String!, $to: String, $channels: [String]) {
    asset(id: $id) {
      id
      name
      uuid
      devicePropertySummary(from: $from, to: $to) {
         name
         avg
         min
         max
         unit
         deviceName
         deviceTypeName
         serial
         deviceId
         outOfServiceAt
      }
      chart(channels: $channels, from: $from, to: $to) {
        nodes {
          name
          deviceName
          deviceSerial
          propertyGroupName
          unit
          avg
          min
          max
          time
        }
      }
    }
  }
`

export const GET_ASSET_REPORT_QUERY = gql`
  query assetReport($id: ID!) {
    asset(id: $id) {
      id
      name
      uuid
      type
      zone {
        id
        name
      }
      company {
        id
        name
        logoFile {
            id
            url
        }
      }
      site {
        id
        name
      }
      devices {
        id
        name
      }
    }
  }
`

export const GET_ASSET_PERFORMANCE_REPORT = gql`
  query getAssetPerformances($id: ID!, $from: String!, $to: String!) {
    asset(id: $id) {
      id
      deviceProperties (reportOnly: true) {
          id
          name
          unit
          deviceName
          deviceId
          deviceSerial
          propertyId
          groupId
          outOfServiceAt
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePerformances(from: $from, to: $to) {
         deviceUuid
         propertyName
         propertyGroupName
         optimalBelowLowCount
         optimalCount
         optimalAboveHighCount
         totalCount
         optimalBelowLowPercentage
         optimalPercentage
         optimalAboveHighPercentage
         deviceName
         incidentBelowLowCount
         incidentAboveHighCount
         incidentBelowLowPercentage
         incidentAboveHighPercentage
         outOfServiceAt
      }
    }
  }
`

export const GET_ZONE_REPORT_QUERY = gql`
  query getZoneForReport($id: ID!) {
    zone(id: $id) {
      id
      name
      type
      company {
        id
        name
        logoFile {
            id
            url
        }
      }
      site{
        id
        name
      }
      assets {
        count
      }
      devices{
        count
      }
    }
  }
`

export const GET_ZONE_PERFORMANCE_REPORT_QUERY = gql`
  query getZonePerformancesForReport($id: ID!, $from: String!, $to: String!) {
    zone(id: $id) {
      id
      deviceGroupProfiles (reportOnly: true) {
          propertyId
          groupId
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePerformances(from: $from, to: $to) {
         assetName
         assetId
         propertyName
         propertyGroupName
         optimalBelowLowCount
         optimalCount
         optimalAboveHighCount
         totalCount
         optimalBelowLowPercentage
         optimalPercentage
         optimalAboveHighPercentage
         incidentBelowLowCount
         incidentAboveHighCount
         incidentBelowLowPercentage
         incidentAboveHighPercentage
         outOfServiceAt
      }
    }
  }
`

export const GET_SITE_REPORT_QUERY = gql`
  query getSiteForReport($id: ID!, $filter: [InputFilter]) {
    site(id: $id) {
      id
      name
      company {
        id
        name
        logoFile {
            id
            url
        }
      }
      assets (filter: $filter) {
        count
      }
      devices (filter: $filter){
        count
      }
    }
  }
`

export const GET_SITE_SUMMARY_REPORT = gql`
  query($id: ID!, $from: String!, $to: String, $assetIds: [ID]) {
    site(id: $id) {
      id
      deviceGroupProfiles (reportOnly: true, assetIds: $assetIds) {
          propertyId
          groupId
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePropertySummary(from: $from, to: $to, assetIds: $assetIds) {
         name
         avg
         min
         max
         stdDev
         mkt
         unit
         deviceName
         deviceTypeName
         serial
         deviceId
         assetId
         assetName
         propertyGroupName
         outOfServiceAt
      }
    }
  }
`

export const GET_SITE_PERFORMANCE_REPORT_QUERY = gql`
  query getSitePerformancesForReport($id: ID!, $from: String!, $to: String!) {
    site(id: $id) {
      id
      deviceGroupProfiles (reportOnly: true) {
          propertyId
          groupId
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePerformances(from: $from, to: $to) {
         zoneName
         zoneId
         propertyName
         propertyGroupName
         optimalBelowLowCount
         optimalCount
         optimalAboveHighCount
         totalCount
         optimalBelowLowPercentage
         optimalPercentage
         optimalAboveHighPercentage
         incidentBelowLowCount
         incidentAboveHighCount
         incidentBelowLowPercentage
         incidentAboveHighPercentage
         outOfServiceAt
      }
    }
  }
`

export const GET_COMPANY_REPORT_QUERY = gql`
  query getCompanyForReport($id: ID!) {
    company(id: $id) {
      id
      name
      logoFile {
            id
            url
      }
      sites {
        count
      }
      assets {
        count
      }
      zones {
        count
      }
      devices{
        count
      }
    }
  }
`

export const GET_COMPANY_PERFORMANCE_REPORT_QUERY = gql`
  query getCompanyPerformancesForReport($id: ID!, $from: String!, $to: String!) {
    company(id: $id) {
      id
      deviceGroupProfiles (reportOnly: true) {
          propertyId
          groupId
          property {
            id
            name
            unit
          }
          propertyGroup {
            id
            name
            isShowInReport
            optimalLow
            optimalHigh
            alarmLow
            alarmHigh
            isIncident
            waitOpen
            waitClose
            deadman
            type
          }
      }
      devicePerformances(from: $from, to: $to) {
         siteName
         siteId
         zoneName
         zoneId
         assetId
         assetName
         propertyName
         propertyGroupName
         optimalBelowLowCount
         optimalCount
         optimalAboveHighCount
         totalCount
         optimalBelowLowPercentage
         optimalPercentage
         optimalAboveHighPercentage
         incidentBelowLowCount
         incidentAboveHighCount
         incidentBelowLowPercentage
         incidentAboveHighPercentage
         outOfServiceAt
      }
    }
  }
`

export const GET_ASSET_TRIPS_REPORT_QUERY = gql`
  query assetTrips($assetId: ID, $page: Int,  $companyId: ID!, $driverId: ID, $customerId: ID, $from: String, $to: String, $sort: [InputSort], $filter: [InputFilter]) {
     trips(page: $page, companyId: $companyId, assetId: $assetId, driverId: $driverId, customerId: $customerId, from: $from, to: $to,  sort: $sort, filter: $filter) {
        count
        page
        pages
        nodes {
          id
          driverId
          vehicleId
          startedAt
          endedAt
          stopTime
          totalDuration
          distanceCovered
          topSpeed
          avgSpeed
          detailedStartAddress
          detailedEndAddress
          nearestWaypointId
          driverRating
          driver{
              id
              firstName
              lastName
          }
          nearestWayPoint{
              id
              name
          }
        }
    }
  }
`

export const GET_INCIDENT_SUMMARY_REPORT_QUERY = gql`
  query incidentSummaryReport ($id: ID!) {
    incident(id: $id) {
      id
      assetName
      assetId
      assetType
      propertyId
      propertyGroupName
      propertyGroupType
      groupId
      type
      worstValue
      unit
      status
      progress
      isAcknowledged
      acknowledgedBy
      acknowledgedByUser {
        id
        email
        firstName
        lastName
        isDeleted
      }
      acknowledgedByContactId
      acknowledgedByContact{
        id
        name
      }
      acknowledgedAt
      openedAt
      createdAt
      closedAt
      property {
        id
        name
      }
      propertyGroup{
        name
        optimalLow
        optimalHigh
        alarmLow
        alarmHigh
      }
      actionsRequired {
        ack {
          required
          actionedAt
        }
        root {
          required
          actionedAt
        }
        corrective {
          required
          actionedAt
        }
        preventative {
          required
          actionedAt
        }
      }
      propertyStatus {
          propertyName
          deviceId
          deviceName
          propertyValue
          unit
          status
          time
      }
      asset {
          id
          name
          uuid
          type
          zone {
            id
            name
          }
          company {
            id
            name
            logoFile {
                id
                url
            }
          }
          site {
            id
            name
          }
      }
    }
  }
`;


export const GET_INCIDENT_REPORT_NOTIFICATION_LOGS_QUERY = gql`
  query notificationLogs ($page: Int,  $companyId: ID, $incidentId: ID, $sort: [InputSort], $filter: [InputFilter]) {
    notificationLogs(page: $page, companyId: $companyId, incidentId: $incidentId, sort: $sort, filter: $filter) {
      count
      pages
      page
      pageSize
      nodes {
        id
        type
        description
        time
        createdAt
        recipient
        status
        companyId
        recipientId
        recipientType
        userId
        user {
          id
          email
          firstName
          lastName
        }
        contactId
        contact {
          id
          name
          email
        }
        metadata
      }
    }
  }
`


export const GET_SYSTEM_CHECKS_QUERY = gql`
  query systemChecks($page: Int, $companyId: ID!, $sort: [InputSort], $type: String, $filter: [InputFilter], $from: String!, $to: String!) {
     systemChecks(page: $page, pageSize: 500, companyId: $companyId, type: $type, sort: $sort, filter: $filter, from: $from,  to: $to) {
        count
        page
        pages
        nodes {
          id
          name
          type
          fromDate
          toDate
          status
          category
          siteId
          completedAt
          completedBy
          completedByUser{
            id
            email
            firstName
            lastName
          }
          lastComment {
            id
            comment
          }
          site {
            id
            name
          }
          zone {
            id
            name
          }
          incidentStats {
            total
            incomplete
          }
          devicePerformances {
                 assetId
                 assetName
                 deviceId
                 deviceName
                 propertyName
                 propertyGroupName
                 propertyGroupId
                 optimalBelowLowCount
                 optimalCount
                 optimalAboveHighCount
                 totalCount
                 optimalBelowLowPercentage
                 optimalPercentage
                 optimalAboveHighPercentage
                 incidentBelowLowCount
                 incidentAboveHighCount
                 incidentBelowLowPercentage
                 incidentAboveHighPercentage
                 outOfServiceAt
          }
       }
    }
  }
`

export const GET_COMPANY_FOR_COMPLIANCE_REPORT_QUERY = gql`
  query getCompanyForComplianceReport($id: ID!) {
    company(id: $id) {
      id
      name
      logoFile {
            id
            url
      }
    }
  }
`
export const GET_COMPANY_FOR_ASSET_PERFORMANCE_HISTORY_REPORT_QUERY = gql`
  query getCompanyForAssetPerformanceHistoryReport($id: ID!) {
    company(id: $id) {
      id
      name
      logoFile {
            id
            url
      }
    }
  }
`


export const GET_ASSET_PERFORMANCE_HISTORY_REPORT_QUERY = gql`
  query assetPerformanceHistory($page: Int,  $companyId: ID!, $from: String!, $to: String!, $filter: [InputFilter]) {
     assets(page: $page, companyId: $companyId, filter: $filter) {
        count
        page
        pages
        nodes {
          id
          uuid
          name
          type
          zone {
            id
            name
          }
          deviceProperties(reportOnly: true) {
              id
              name
              unit
              assetId
              deviceName
              deviceId
              deviceSerial
              deviceUuid
              propertyId
              groupId
              outOfServiceAt
              property {
                id
                name
                unit
              }
              propertyGroup {
                id
                uuid
                name
                isShowInReport
                optimalLow
                optimalHigh
                alarmLow
                alarmHigh
                isIncident
                waitOpen
                waitClose
                deadman
                type
              }
          }
          devicePropertiesHistory(reportOnly: true) {
              id
              name
              unit
              assetId
              deviceName
              deviceId
              deviceUuid
              deviceSerial
              propertyId
              groupId
              outOfServiceAt
              property {
                id
                name
                unit
              }
              propertyGroup {
                id
                name
                isShowInReport
                optimalLow
                optimalHigh
                alarmLow
                alarmHigh
                isIncident
                waitOpen
                waitClose
                deadman
                type
              }
          }
          devicePerformances(from: $from, to: $to) {
               deviceUuid
               deviceName
               propertyName
               propertyGroupId
               propertyId
               propertyGroupName
               optimalBelowLowCount
               optimalCount
               optimalAboveHighCount
               totalCount
               optimalBelowLowPercentage
               optimalPercentage
               optimalAboveHighPercentage
               incidentBelowLowCount
               incidentAboveHighCount
               incidentBelowLowPercentage
               incidentAboveHighPercentage
               outOfServiceAt
          }
          devicePropertySummary(from: $from, to: $to) {
                 name
                 avg
                 min
                 max
                 stdDev
                 mkt
                 last
                 lastTime
                 unit
                 deviceName
                 deviceTypeName
                 propertyGroupName
                 propertyGroupType
                 propertyGroupId
                 propertyId
                 serial
                 deviceUuid
                 deviceId
                 outOfServiceAt
          }
        }
    }
  }
`
